import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import SimplePanel from '@/shared/components/SimplePanel';
import FormattedListValue from '@/shared/components/FormattedListValue';
import utils from '@/shared/utils/adminpulse';
import messages from '../jobMessages';

const fieldMessages = defineMessages({
  SendInvoiceStrategy: 'Send invoice strategy',
  StartDate: 'Start date',
  PaymentMethod: 'Payment method',
  InvoiceDocumentTemplate: 'Invoice document template',
  InvoiceDetailDocumentTemplate: 'Invoice detail document template',
  CreditNoteDocumentTemplate: 'Credit note document template',
  InvoiceDetailType: 'Invoice detail type',
});

const fieldIdToMessageKey = {
  1: fieldMessages.SendInvoiceStrategy,
  2: fieldMessages.StartDate,
  3: fieldMessages.PaymentMethod,
  4: fieldMessages.InvoiceDocumentTemplate,
  5: fieldMessages.InvoiceDetailDocumentTemplate,
  6: fieldMessages.CreditNoteDocumentTemplate,
  7: fieldMessages.InvoiceDetailType,
};

const JobDetailUpdateInvoiceStreamField = ({ job, intl }) => {
  const parameters = utils.toCamel(job.parameters);
  const fieldId = parameters.field;
  const fieldLabel = fieldIdToMessageKey[fieldId];
  if (!fieldLabel) return null;
  return (
    <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Field} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <span>{intl.formatMessage(fieldLabel)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SimplePanel>
  );
};

JobDetailUpdateInvoiceStreamField.propTypes = {
  job: PropTypes.shape({}).isRequired,
};

export default injectIntl(JobDetailUpdateInvoiceStreamField);
